/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { SdsDivProps } from '../Component.props';
import { ActivityLogEvent, ActivityLogIconMap } from './ActivityLog.defs';

/**
 * The props for `<ActivityLog />`.
 */
export interface ActivityLogProps extends SdsDivProps {
  /**
   * Message to display when no logs are present.
   */
  emptyMessage?: React.ReactNode;

  /**
   * Map of icons that relate to the type.
   */
  iconMap: ActivityLogIconMap;

  /**
   * Unique key identifier.
   */
  key: string;

  /**
   * Specify the limit of items to show. Use -1 for no limit.
   */
  limit: number;

  /**
   * The list of activity logs.
   */
  logs: Array<ActivityLogEvent>;

  /**
   * Text to display alongside timestamp.
   */
  timestampDescription?: string;

  /**
   * Component title.
   */
  title?: string;
}

/**
 * The default prop values for `<ActivityLog />`.
 */
export const activityLogDefaults = {
  emptyMessage: <span>{`No activities could be found.`}</span>,
  timestampDescription: `Last updated`,
  title: `Activity log`,
};
